<template>
  <div
    :class="{ 'v-expansion-panel__container--active': isActive }"
    class="panel-add v-expansion-panel__container"
  >
    <a
      href=""
      class="v-expansion-panel__header panel-add__header"
      @click.prevent="isActive = !isActive">
      <h4 class="panel-add__label">
        <v-icon small>add_circle</v-icon>
        Add {{ hasFollows ? 'another' : 'an' }} account
      </h4>
      <div class="v-expansion-panel__header__icon">
        <v-icon>keyboard_arrow_down</v-icon>
      </div>
    </a>
    <transition
      :css="false"
      @enter="enter"
      @leave="leave"
    >
      <div
        v-if="isActive"
        class="v-expansion-panel__body panel-add__body"
      >
        <v-card class="grey darken-4 panel-add__card">
          <service-type-recommendations
            :popular-providers="[]"
            :service-type="null"
            :is-active="isActive" />
        </v-card>
      </div>
    </transition>
  </div>
</template>

<script>
  import ServiceTypeRecommendations from './ServiceTypeRecommendations'
  import { mapState } from 'vuex'
  import sidebarMixin from '@/mixins/sidebar'

  export default {
    mixins: [sidebarMixin],
    data: function () {
      return {
        isActive: false
      }
    },
    computed: {
      ...mapState('folders', ['pending', 'folders']),
      hasFollows () {
        return this.folders && this.folders.length
      }
    },
    watch: {
      // Once pending, collapse the panel
      pending () {
        this.isActive = false
      }
    },
    components: {
      ServiceTypeRecommendations
    }
  }
</script>

<style lang="stylus">
  .panel-add
    &__header
      color: white
      text-decoration: none
    &__label
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
    &__card
      min-height: 20rem
</style>



// WEBPACK FOOTER //
// frontend/src/components/recommendations/AddAnother.vue